<template>
  <div class="content">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-alert :closable="false" title="请下载模板，并按照模板提示输入数据后上传" type="info" show-icon></el-alert>
      </div>
      <div style="margin-left:30px">
        <div style="font-size: 14px;text-align: left;">1、请选择模板下载；</div>
        <div style="font-size: 14px;text-align: left;">2、导入必须是xls/xlsx文件；</div>
        <div style="font-size: 14px;text-align: left;">3、只导入EXCEL文件的第一个标签页；</div>
        <div style="font-size: 14px;text-align: left;">4、文件大小最大为10MB；</div>
        <div style="font-size: 14px;text-align: left;"> 5、请按模板格式填写；</div>
        <div style="font-size: 14px;text-align: left;"> 6、单文件修改条数最大为10000条；</div>
        <div style="font-size: 14px;text-align: left;"> 7、批量操作需要一定时间，上传后到任务中心查询进度；</div>
        <div style="font-size: 14px;text-align: left;"> 8、如果上传的是ESIM卡，需要添加PIN、PUK、ESIM_URL三个字段；</div>
      </div>
    </el-card>
    <el-card class="box-card">
      <el-form :model="ruleForm" :inline="false" ref="ruleForm" label-width="150px"  :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="运营商:" prop="operatorId" >
              <el-select v-model="ruleForm.operatorId" filterable placeholder="请选择运营商" @change="operation" style="width:100%">
                <el-option
                  v-for="item in operationList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="卡源：" prop="cardSourceId" >
              <el-select filterable v-model="ruleForm.cardSourceId" placeholder="请选择卡源" style="width:100%" @change="handleChangeSource">
                <el-option
                  v-for="item in sourceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> 
        <el-row v-if="sourceGroupData.length>0">
          <el-col :span="12">
            <el-form-item label="群组：" prop="groupId" >
              <el-select filterable v-model="ruleForm.groupId" placeholder="请选择群组" style="width:100%">
                <el-option
                  v-for="item in sourceGroupData"
                  :key="item.groupId"
                  :label="getGroupLabel(item)"
                  :value="item.groupId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>  
        <el-row>
          <el-col :span="12">
            <el-form-item label="网络：" prop="networkType" >
              <el-select v-model="ruleForm.networkType" placeholder="请选择网络" style="width:100%">
                <el-option
                  v-for="item in networkList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>     
        <el-row>
          <el-col :span="12">
            <el-form-item label="物理卡类型：" prop="cardPhysicalName" >
              <el-select v-model="ruleForm.cardPhysicalName" filterable placeholder="请选择物理卡类型" style="width:100%" >
                <el-option
                  v-for="dict in dict.type.card_physical_name"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="卡品类型：" prop="cardTypeSortName" >
              <el-select v-model="ruleForm.cardTypeSortName" filterable placeholder="请选择卡品类型" style="width:100%">
                <el-option
                  v-for="dict in dict.type.card_type_sort_name"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="卡类型：" prop="cardInfoTypeName">
              <el-select v-model="ruleForm.cardInfoTypeName" filterable placeholder="请选择卡类型" style="width:100%">
                <el-option
                  v-for="dict in dict.type.card_type_name"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="卡测沉期：" prop="cardInfoRequireName" :required="true" >
              <el-select v-model="ruleForm.cardInfoRequireName" placeholder="请选择卡测沉期" style="width:100%">
                <el-option
                  v-for="dict in dict.type.card_require_name"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="卡定向类型：" >
              <el-select v-model="ruleForm.orientations" placeholder="请选择定向类型" style="width:100%">
                <el-option
                  v-for="item in orientationList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>    
         
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否需要实名：" prop="needKyc" :required="true" >
              <el-select v-model="ruleForm.needKyc" placeholder="请选择是否需要实名" style="width:100%">
                <el-option
                    v-for="item in needKycs"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="ruleForm.needKyc == 1">
          <el-col :span="12">
            <el-form-item label="实名方式：" prop="cardCertType" :required="true" >
              <el-select v-model="ruleForm.cardCertType" placeholder="请选择实名方式" style="width:100%" >
                <el-option
                    v-for="item in cardCertTypes"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Excel文件：" prop="file" >
              <el-upload
                ref="upload"
                :limit="1"
                accept=".xlsx, .xls"
                action
                :auto-upload="true"
                :http-request="httpRequest"
                drag
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip text-center" style="text-align: left;" slot="tip">
                  <span>仅允许导入xls、xlsx格式文件。</span>
                  <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;" @click="importTemplate">下载模板</el-link>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>    
        <el-form-item>
          <el-button type="primary" size="medium" @click="submitForm('ruleForm')" >提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { cardBaseInfo ,cardSource ,importCard ,selectCardSourceFlow } from "@/api/api.js"; //卡导入的卡类型、卡要求、网络、运营商等基本信息,查询卡源,上传导入的信息,卡类型三级树
export default {
  dicts : [ 'card_physical_name','card_type_sort_name','card_type_name','card_require_name' ],
  name:'import',
  data() {
    var checkFile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请上传EXCEL文件'));
      }else{
        callback();
      }
    };
    return {
      ruleForm: {
        operatorId:undefined,
        file:undefined,
        orientations:'',
        needKyc:0,
        cardCertType:undefined,
        serviceProviderId:'',
        groupId:'',
        cardPhysicalName:undefined,
        cardTypeSortName:undefined,
        cardInfoTypeName:undefined,
        cardInfoRequireName:undefined,
      },
      submitLoading:false,
      // 表单验证
			rules:{
				operatorId: [
          { required: true, message: "请选择运营商", trigger: "blur" }
				],
				cardSourceId: [
          { required: true, message: "请选择卡源", trigger: "blur" }
				],
        groupId:[
          { required: true, message: "请选择卡源对应的群组", trigger: "blur" }
        ],
				networkType: [
          { required: true, message: "请选择网络", trigger: "blur" }
				],
				file: [
          { required: true,validator: checkFile, trigger: "blur" }
				],
        cardPhysicalName: [
          { required: true, message: "请选择物理卡类型", trigger: "blur" }
				],
        cardInfoRequireName: [
          { required: true, message: "请选择卡要求", trigger: "blur" }
				],
        cardTypeSortName:[
          { required: true, message: "请选择卡品类型", trigger: "blur" }
        ],
        cardInfoTypeName:[
          { required: true, message: "请选择卡类型", trigger: "blur" }
        ],
        needKyc: [
          { required: true, message: "请选择是否需要实名", trigger: "blur" }
				],
        cardCertType: [
          { required: true, message: "请选择实名类型", trigger: "blur" }
        ],
			},
      operationList: [],
      sourceList: [],
      networkList: [],
      orientationList: [],
      fileList: [],
      needKycs:[{id:0,name:'不需要'},{id:1,name:'需要'}],
      cardCertTypes:[{id:1,name:'本地实名'},{id:2,name:'运营商实名'}],
      sourceGroupData:[],
    };
  },
  methods: {
    httpRequest(param) {
      this.ruleForm.file = param.file;
    },
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if(valid){
          let config = {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          };
          let formData = new FormData();
          formData.append("file", this.ruleForm.file);
          formData.append("operatorId", this.ruleForm.operatorId);
          formData.append("cardSourceId", this.ruleForm.cardSourceId);
          formData.append("groupId", this.ruleForm.groupId);
          formData.append("serviceProviderId", this.ruleForm.serviceProviderId);
          formData.append("networkType", this.ruleForm.networkType);
          formData.append("cardInfoRequireName", this.ruleForm.cardInfoRequireName);
          formData.append("cardTypeSortName", this.ruleForm.cardTypeSortName);
          formData.append("cardInfoTypeName", this.ruleForm.cardInfoTypeName);
          formData.append("cardPhysicalName", this.ruleForm.cardPhysicalName);
          formData.append("orientations", this.ruleForm.orientations);
          formData.append("needKyc", this.ruleForm.needKyc);

          if(this.ruleForm.needKyc == 1){
            formData.append("cardCertType", this.ruleForm.cardCertType);
          }
          importCard(formData, config).then(res => {
              this.$notify({
                title: "提示",
                message: "已提交卡导入，请在任务中心查看进度",
                type: "success",
                offset:30
              });
              this.resetForm("ruleForm");
              this.$refs.upload.clearFiles()
              setTimeout(()=>{
                this.$router.push({ path: `/taskCenter/missionList`});
              },1000)
          })
        }
      })
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    // 提交运营商出现对应的卡源
    operation(val) {
      let params = {
        operatorId:val
      }
      cardSource(params).then(res => {
        this.sourceList = res.data.data
      });
    },
    //选择卡源后的操作 只有onelink移动卡源
    handleChangeSource(id){
      this.sourceGroupData = []
      if(this.ruleForm.operatorId == '2'){
        selectCardSourceFlow({id}).then(res=>{
          this.sourceGroupData = res.data.data
        })
      }
    },
    getGroupLabel(group){
      if(group.apnName){
        return group.groupId + '[' + group.groupName + ']'+ '[' + group.apnName + ']'
      }
      return group.groupId + '[' + group.groupName + ']'
    },
    /** 下载模板操作 */
    importTemplate() {
      this.download('/card/importTemplate', {
      }, `card_importTemplate_${new Date().getTime()}.xlsx`)
    },
  },
  created() {
    cardBaseInfo().then(res =>{
      this.networkList = res.data.data.network;
      this.operationList = res.data.data.operators;
      this.orientationList = res.data.data.orientations;
    })
  },
  mounted() {

  }
};
</script>
<style lang="less" scoped>

</style>
